import { plural } from '@smh/utils/strings';
import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiBtn, JtnUiSharePopover } from '@jtnews/jtn-ui';

import { injectStylesMixin } from '../../../mixins';

import styles from './record-actions.styles.scss?module';

type Events = {
  onClickedComments: void;
  onClickedBookmark: void;
  onShared: string;
};

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'RecordActions',
    props: {
      commentsUrl: {
        type: String,
        required: false
      },
      discussUrl: {
        type: String,
        required: false
      },
      isBookmarked: {
        type: Boolean,
        default: false
      },
      isCommentsAllowed: {
        type: Boolean,
        default: true
      },
      comments: {
        type: Number,
        default: 0
      }
    },
    computed: {
      commentsCountText() {
        return this.comments === 0
          ? 'Написать комментарий'
          : `${this.comments} ${plural(this.comments, [
              'комментарий',
              'комментария',
              'комментариев'
            ])}`;
      },
      commentsOrDiscussUrl() {
        return this.comments === 0 ? this.discussUrl : this.commentsUrl;
      },
      bookmarkText() {
        return this.isBookmarked ? 'В закладках' : 'Сохранить в закладки';
      }
    },
    render() {
      return (
        <div class={styles.wrapper}>
          <div class={styles.group}>
            {this.isCommentsAllowed ? (
              <JtnUiBtn
                href={this.commentsOrDiscussUrl}
                class={styles.actionBtn}
                theme="white"
                onClick={() => this.$emit('clickedComments')}
              >
                <template slot="left">
                  <svg width={24} height={24}>
                    <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-discuss"></use>
                  </svg>
                </template>
                {this.commentsCountText}
              </JtnUiBtn>
            ) : (
              <JtnUiBtn
                class={styles.actionBtn}
                theme="white"
                onClick={() => this.$emit('clickedBookmark')}
              >
                <template slot="left">
                  {this.isBookmarked ? (
                    <svg width={24} height={24} class={styles.bookmarkActiveIcon}>
                      <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-bookmark-solid"></use>
                    </svg>
                  ) : (
                    <svg width={24} height={24}>
                      <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-bookmark-outline"></use>
                    </svg>
                  )}
                </template>
                {this.bookmarkText}
              </JtnUiBtn>
            )}
            {this.$slots.retell}
          </div>
          <div class={styles.group}>
            {this.isCommentsAllowed && (
              <JtnUiBtn
                class={[styles.actionBtn, styles.smallBtn]}
                theme="white"
                onClick={() => this.$emit('clickedBookmark')}
              >
                <template slot="left">
                  {this.isBookmarked ? (
                    <svg width={24} height={24} class={styles.bookmarkActiveIcon}>
                      <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-bookmark-solid"></use>
                    </svg>
                  ) : (
                    <svg width={24} height={24}>
                      <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-bookmark-outline"></use>
                    </svg>
                  )}
                </template>
              </JtnUiBtn>
            )}
            <JtnUiSharePopover
              onShared={value => this.$emit('shared', value)}
              socials={['vk', 'twitter', 'ok', 'telegram', 'wa']}
            />
          </div>
        </div>
      );
    }
  });
